module.exports = "./img/1fdbce96a94fa0df3c3f16607d0772a9.png";